import cn from 'clsx'

// Components
import { Image } from '@tracklib/kit'

// Utils
import { CDN_ROOT } from '@constants'

import styles from './cover.css'

const firstThree = (_: string, index: number) => index < 3

type CoverProps = {
  className?: string
  datatesting?: string
  collection: {
    covers: Array<string>
    crate?: string
  }
}

const Cover = ({ className, datatesting, collection }: CoverProps): JSX.Element | null => {
  if (!collection) {
    return null
  }
  const { covers, crate } = collection
  if (!covers || covers.length === 0) {
    return (
      <div className={cn(styles.wrapper, className)} datatesting={datatesting}>
        <div
          className={styles.placeholder}
          style={{
            backgroundImage: "url('/static/images/placeholder-collection.png')",
          }}
        />
      </div>
    )
  }

  if (crate) {
    return (
      <div className={cn(styles.crateWrapper, className)}>
        <ol className={styles.stack}>
          {covers.filter(firstThree).map((cover, i) => (
            <li className={styles[`stack${i}` as keyof typeof styles] as string} key={cover}>
              <Image alt="Album cover art" image={cover} key={String(i)} sizes="(min-width: 769px) 25vw, 100vw" square absolute />
            </li>
          ))}
        </ol>
        <img
          src={`${CDN_ROOT}400x0/${crate}`}
          srcSet={`${CDN_ROOT}200x0/${crate} 1x, ${CDN_ROOT}400x0/${crate} 2x`}
          alt="Collection crate"
          className={styles.crate}
        />
      </div>
    )
  }

  if (covers.length > 3) {
    return (
      <div className={cn(styles.wrapper, className)} datatesting={datatesting}>
        <div className={styles.grid}>
          {covers.map((cover, i) => (
            <Image alt="" image={cover} key={String(i)} sizes="(min-width: 769px) 25vw, 100vw" square />
          ))}
        </div>
      </div>
    )
  }

  return (
    <div className={cn(styles.wrapper, className)} datatesting={datatesting}>
      <Image alt="" image={covers[0]} absolute sizes="(min-width: 769px) 25vw, 100vw" square />
    </div>
  )
}

export default Cover
